import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const SiteNavigationElementSchema = ({ navigationElementId, siteUrl, pages }) => {
  const navigationData = {
    '@context': 'http://schema.org',
    '@graph': pages.map(({ slug, title }) => ({
      '@context': 'https://schema.org',
      '@type': 'SiteNavigationElement',
      '@id': navigationElementId,
      name: title,
      url: `${siteUrl}${slug}`,
    })),
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(navigationData)}</script>
    </Helmet>
  );
};

export default SiteNavigationElementSchema;

SiteNavigationElementSchema.propTypes = {
  navigationElementId: PropTypes.string,
  siteUrl: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

SiteNavigationElementSchema.defaultProps = {
  navigationElementId: '#nav',
};
